/**
 * @generated SignedSource<<8c4b55789dc428b64fd7cd7a36c658a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type bidModalTrackingHelpers_item$data = {
  readonly getCategoriesByLevel: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly relevantAuctionSolution: {
    readonly minNextBidAmount: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly serviceId: string | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "bidModalTrackingHelpers_item";
};
export type bidModalTrackingHelpers_item$key = {
  readonly " $data"?: bidModalTrackingHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"bidModalTrackingHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "bidModalTrackingHelpers_item"
};

(node as any).hash = "aff252fb95c0b8e4f1181b578cacc19d";

export default node;
